'use strict';

/**
 * @classname Faq
 * @classdesc FAQアコーディオン
 */
export default class Faq {
	/**
	 * @constructor
	 * @param {jQuery} $e - .list--faq
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$list = $e;
		this._$list.find('.btn--question').on('click', (e) => this.onClickQuestion(e));
	};

	/**
	 * 質問クリックのコールバック
	 *
	 * @memberof Faq
	 * @return undefined
	 */
	onClickQuestion(e) {
		const $btn = $(e.currentTarget);
		const $answer = $btn.next('.faq__answer');
		const isOpen = $btn.hasClass('is-open');

		this._$list.find('.btn--question.is-open').not($btn).removeClass('is-open');
		this._$list.find('.faq__answer').not($answer).slideUp(200);

		$btn.toggleClass('is-open', !isOpen);
		isOpen ? $answer.slideUp(200) : $answer.slideDown(200);
	}
};
